module.exports = __webpack_public_path__ + "static/media/plan-C5-desktop-sc.79546aaf.png";